var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgV6ProjectSettingsIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.375 5.625H5.625V9.375H9.375V5.625ZM5.625 3.75H9.375H11.25V5.625V9.375V11.25H9.375H5.625H3.75V9.375V5.625V3.75H5.625ZM9.375 15.625H5.625V19.375H9.375V15.625ZM5.625 13.75H9.375H11.25V15.625V19.375V21.25H9.375H5.625H3.75V19.375V15.625V13.75H5.625ZM15.625 5.625V9.375H19.375V5.625H15.625ZM13.75 3.75H15.625H19.375H21.25V5.625V9.375V11.25H19.375H15.625H13.75V9.375V5.625V3.75ZM18.4375 13.125V14.0625V16.5625H20.9375H21.875V18.4375H20.9375H18.4375V20.9375V21.875H16.5625V20.9375V18.4375H14.0625H13.125V16.5625H14.0625H16.5625V14.0625V13.125H18.4375Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV6ProjectSettingsIcon);
export default __webpack_public_path__ + "static/media/v6-project-settings-icon.c349cd79129a246406a1131630c8ebc5.svg";
export { ForwardRef as ReactComponent };